import * as AffiliateCommission from "./AffiliateCommission";
import * as BillingAndPackage from "./BillingAndPackage";
import * as HolidaySetting from "./HolidaySetting";
import * as AppointmentListMEH from "react-lib/apps/MEH/sequence/AppointmentListMEH"
import * as SaveServiceOrder from "react-lib/apps/MEH/sequence/SaveServiceOrder"
import * as ScheduleSetting from "./ScheduleSetting";
import * as MakeAppointmentMeHey from "./MakeAppointmentMeHey";
import * as PaymentSummary from "./PaymentSummary"
import * as PaymentHistory from "./PaymentHistory"
import * as MeBillingI from "./MeBilling";
import * as MeChart from "./MeChart";
import * as MeScript from "./MeScript";
import * as MeReport from "./MeReport";
import * as PatientQueue from "./PatientQueue";
import * as AffiliateSettings from "./AffiliateSettings";
import * as SharedLabResult from "./SharedLabResult"


const SequencePattern: Record<string, Record<string, Record<string, any>>> = {
  BillingAndPackage: {
    default: {
      START: BillingAndPackage.Start,
      Action: BillingAndPackage.Action,
    },
  },
  HolidaySetting: {
    default: {
      START: HolidaySetting.Start,
      Action: HolidaySetting.Action,
    },
  },
  ScheduleSetting: {
    default: {
      START: ScheduleSetting.Start,
      Action: ScheduleSetting.Action,
    },
  },
  MakeAppointmentMeHey: {
    default: {
      START: MakeAppointmentMeHey.Start,
      Action: MakeAppointmentMeHey.Action,
    },
  },
  AppointmentListMEH: {
    default: {
      START: AppointmentListMEH.Start,
      Action: AppointmentListMEH.Action,
    },
  },
  SaveServiceOrder: {
    default: {
      START: SaveServiceOrder.Start,
      Action: SaveServiceOrder.Action,
    }
  },
  MeBilling: {
    default: {
      START: MeBillingI.Start,
      Action: MeBillingI.Action,
    },
  },
  PaymentSummary: {
    default: {
      START: PaymentSummary.Start,
      Action: PaymentSummary.Action,
    },
  },
  PaymentHistory: {
    default: {
      START: PaymentHistory.Start,
      Action: PaymentHistory.Action,
    },
  },
  MeChart: {
    default: {
      START: MeChart.Start,
      Action: MeChart.Action,
    },
  },
  MeScript: {
    default: {
      START: MeScript.Start,
      Action: MeScript.Action,
    },
  },
  MeReport: {
    default: {
      START: MeReport.Start,
      Action: MeReport.Action,
    },
  },
  PatientQueue: {
    default: {
      START: PatientQueue.Start,
      Action: PatientQueue.Action,
    },
  },
  AffiliateCommission: {
    default: {
      START: AffiliateCommission.Start,
      Action: AffiliateCommission.Action,
    },
  },
  AffiliateSettings: {
    default: {
      START: AffiliateSettings.Start,
      Action: AffiliateSettings.Action,
    },
  },
  SharedLabResult: {
    default: {
      START: SharedLabResult.Start,
      Action: SharedLabResult.Action,
    }
  }
};

export default SequencePattern;
